import React from 'react'
import { Stack, Typography, Paper, Skeleton } from '@mui/material'

const Rounds: React.FC = () => {
  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography variant="h4" component="h1">
          Active Rounds
        </Typography>
        <Typography color="text.secondary">
          Manage live competition rounds here with start/stop controls, SSE updates, and AI-assisted correctness checks.
        </Typography>
      </Stack>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Skeleton variant="text" width="50%" sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={140} sx={{ borderRadius: 2, mb: 1.5 }} />
        <Skeleton variant="text" width="70%" />
      </Paper>
    </Stack>
  )
}

export default Rounds
